module.exports = __webpack_public_path__ + "media/images/application/template/map-pin-6ff87c7681320947161d4aa41e11df01.png";